import PlayText, { TYPES } from 'app/ui-components/typography/PlayText/PlayText';
import { PlayTextStyles } from 'app/ui-components/typography/PlayText/PlayText.styles';
import styled, { keyframes, css } from 'styled-components';
import {
    fontWeightBold,
    playTransitionCubicEaseInOut,
    regularBlack,
    regularWhite,
} from '../../ui-components/design-tokens';
import ExternalLink from '../Link/ExternalLink';

export const ErrorHeadline = styled.h2.attrs({ type: TYPES.XLARGE })`
    ${PlayTextStyles}
    color: ${regularWhite};
`;

export const RightsLink = styled(ExternalLink)`
    font-weight: ${fontWeightBold};
    display: flex;
    line-height: 1;
    align-items: center;
`;

export const Description = styled(PlayText)`
    display: block;
    margin-top: 10px;
`;

export const ErrorContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;
`;

const fade = keyframes`
    0% {
        opacity: 0;
    }
    80% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;

const slashAnimation = keyframes`
    from {
        transform: scale(0);
    }
    to {
        transform: scale(10);
    }
`;

export const SlashAnimation = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${regularBlack};
    z-index: 899;
    clip-path: polygon(60% 0, 75% 0, 40% 100%, 25% 100%);
    transform-origin: center center;
    animation: ${slashAnimation} 0.5s cubic-bezier(0.835, 0.025, 0.795, 0.035) forwards;
    backface-visibility: hidden;

    @media screen and (prefers-reduced-motion: reduce) {
        animation: none;
        transform: scale(10);
    }
`;

export const Container = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 900;
    width: 100%;
    height: 100%;
    opacity: 0;

    ${(props) => props.hidden && `display: none;`}

    ${(props) =>
        !props.hidden &&
        css`
            opacity: 1;
            animation: ${fade} 600ms ${playTransitionCubicEaseInOut};
        `}
`;
